import { render, staticRenderFns } from "./DateFilterPeople.vue?vue&type=template&id=4afd08f8"
import script from "./DateFilterPeople.vue?vue&type=script&lang=js"
export * from "./DateFilterPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports